import { Dictionary } from '@reduxjs/toolkit';
import { PaintTarget } from '@ff-os/rendering-shared/targets';
import { GiftJson } from './GiftJson';
import { variablePlugins } from './registry';

export const createPaintables = (
    variables: GiftJson.Variable<any>[],
    input: Dictionary<GiftJson.Input<any>>,
    variant: GiftJson.Variant<any>,
    jwt: string | null,
    target: PaintTarget
) => {
    return variables.flatMap(v => variablePlugins
        .require(v.pluginId)
        .toFfCanvas(v, input[v.id]!.value, variant.palette || {}, target, jwt));
};